module.exports = __webpack_public_path__ + "/login_ui/img/mu-562726edc3340d6b572f1466b1db7306.svg";